import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import 'lib-flexible/flexible.js'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
import promise from 'es6-promise';
promise.polyfill();

// 引入 Vant
import { Button, Toast, Lazyload, Popup,Uploader  ,PullRefresh  ,Overlay , Tabbar, TabbarItem,Tag, List, Icon,Picker ,TreeSelect , Panel, Image, Field, CellGroup,  Cell, Row, Col, Checkbox, PasswordInput, NumberKeyboard, NavBar, Sticky, IndexBar, IndexAnchor, Swipe, SwipeItem, Grid, GridItem,Radio, RadioGroup, Tab, Tabs, Notify, ActionSheet,Dialog} from 'vant';
Vue.use(Button).use(Toast).use(Lazyload).use(Popup).use(Tabbar).use(Overlay).use(PullRefresh ).use(TabbarItem).use(Uploader ).use(Tag).use(List).use(Icon).use(Panel).use(Image).use(Field).use(Cell).use(CellGroup).use(Row).use(Col).use(Checkbox).use(PasswordInput).use(NumberKeyboard).use(NavBar).use(Sticky).use(IndexBar).use(IndexAnchor).use(Swipe).use(SwipeItem).use(Grid).use(GridItem).use(Radio).use(RadioGroup).use(Tab).use(Tabs).use(Picker).use(TreeSelect).use(Notify).use(ActionSheet).use(Dialog);


//引入font-awesome
import 'font-awesome/css/font-awesome.css';



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => { 
  if(to.meta.title) {
    document.title = to.meta.title;
  }
  
  next();
});
